import { render, staticRenderFns } from "./button-selection.vue?vue&type=template&id=371d091a&"
import script from "./button-selection.vue?vue&type=script&lang=js&"
export * from "./button-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371d091a')) {
      api.createRecord('371d091a', component.options)
    } else {
      api.reload('371d091a', component.options)
    }
    module.hot.accept("./button-selection.vue?vue&type=template&id=371d091a&", function () {
      api.rerender('371d091a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/button-selection.vue"
export default component.exports